<mat-card appearance="outlined" class="mat-elevation-z4 mat-card-scrollable">
    <mat-card-header>
        <mat-card-title>{{ 'Dashboard.Top10ShareholdersChart' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="wrapper">
                    <igx-pie-chart
                        [dataSource]="chartData"
                        [labelsPosition]="'BestFit'"
                        width="100%"
                        height="100%"
                        legendLabelMemberPath="label"
                        labelMemberPath="label"
                        valueMemberPath="value" />
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
